import React from "react";
import apiUrl from "../../apiUrlConstant";
import { Bar } from "react-chartjs-2";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { JsonToExcel } from "react-json-to-excel";
import { exceldataFormate } from "../../utils/utils";
import { Loader } from 'rsuite';  
import domtoimage from 'dom-to-image';
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class InventoryByCity extends React.Component {
  state = {
    inventoryByCity: {},
    xAxis: [],
    barThicknesS: 10,
    chartOtions: {},
    chartData: {
      labels: [],
      datasets: [],
    },
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const superClass = this;
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          stacked: true,
          grid: {
            display: false,
          },
          ticks: {
            autoSkip: false,
            color: "black",
            font: {
              size: 10,
            },
          },
        },
        y: {
          stacked: true,
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "Area (sqft)",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: "rgb(0, 0, 0)",
            boxWidth: 6,
            boxHeight: 6,
            usePointStyle: true,
          },
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
        },
      },
    };
    fetch(
      `${apiUrl.apiUrl.url}/dashboard/inventory-by-city?search=` +
        this.props.searchTerm +
        `&assetVal=${this.props.assetVal}&leaseStatus=${this.props.leaseStatus}&occupierVal=${this.props.occupierVal}`,
      {
        headers,
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        this.setState({ inventoryByCity: data.datapoints });
        var convertedData = exceldataFormate(data);
        const data1 = {
          labels: data.x,
          datasets: [
            {
              label: data.legend.y1,
              data: data.datapoints.y1,
              backgroundColor: data.bgcolor.y1,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },
            {
              label: data.legend.y3,
              data: data.datapoints.y3,
              backgroundColor: data.bgcolor.y3,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },
            {
              label: data.legend.y2,
              data: data.datapoints.y2,
              backgroundColor: data.bgcolor.y2,
              borderWidth: 0,
              barThickness: this.state.barThicknesS,
              borderRadius: 10,
              stack: "Stack 0",
            },
          ],
        };

        superClass.setState({
          chartOtions: options,
          chartData: data1,
          isLoad: true,
          convertedData: convertedData,
        });
      });
  }

  downloadPdf = () => {
    const input = document.getElementById("inventoryByCity");
    domtoimage.toPng(input).then((canvas) => {
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(canvas);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(canvas, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("inventoryByCity.pdf");
    });
  };

  render() {
    return (
      <>
        <div className="row m-0">
          <div className="col-lg-6 p-0">
            <h4>Inventory by City</h4>
          </div>
          <div className="col-lg-6 p-0 float-right">
            <Dropdown style={{ float: "right" }}>
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="chartDownloadContainer"
              ></Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={(e) => {
                    this.downloadPdf();
                  }}
                >
                  Download as PDF
                </Dropdown.Item>
                <Dropdown.Item>
                  <JsonToExcel
                    title="Download as Excel"
                    data={this.state.convertedData}
                    fileName="InventoryByCity"
                    btnClassName="graphExcelDownloadBtn"
                  />
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="col-12 text-center position-relative" id="inventoryByCity">
            {
              (this.state.chartData.datasets.length == 0) && 
              <Loader size="lg" content="Loading... " center /> 
            }
            
            <Bar options={this.state.chartOtions} data={this.state.chartData} />
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(InventoryByCity);
